import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { Popover, PopoverHeader } from "reactstrap";

import { LoginContext } from "../../Tienda/components/ParadigmaLoginProvider/ParadigmaLoginProvider";
import { CartContext } from "../../Tienda/components/ParadigmaCartProvider/ParadigmaCartProvider";
import "./header.scss";

const DropdownMenuLoggedComponent = ({
  logout,
  classNames,
  displayname,
  isOpen,
  target,
  toggle,
}) => (
  <Popover
    className={`${classNames} popover-menu-account`}
    isOpen={isOpen}
    target={target}
    placement="bottom"
    toggle={toggle}
    trigger="legacy"
  >
    <PopoverHeader>{displayname}</PopoverHeader>
    {displayname?.toLowerCase() !== "invitado@martinez.com" && (
      <>
        <NavLink
          className="nav-link"
          to="/tienda/cliente/perfil"
          onClick={toggle}
        >
          <i className="fa fa-user"></i> Editar Datos
        </NavLink>
        <NavLink
          className="nav-link"
          to="/tienda/cliente/compras"
          onClick={toggle}
        >
          <i className="fa fa-cart-arrow-down" aria-hidden="true"></i>{" "}
          Historial de Compras
        </NavLink>
        <NavLink
          className="nav-link"
          to="/tienda/cliente/resumencuenta"
          onClick={toggle}
        >
          <i className="fa fa-credit-card" aria-hidden="true"></i> Estado de
          Cuenta
        </NavLink>
      </>
    )}
    <button
      type="button"
      className="nav-link login-nav__button"
      onClick={() => {
        toggle();
        logout();
      }}
      style={{ color: "red" }}
    >
      <i className="fa fa-sign-out"></i> Salir
    </button>
  </Popover>
);

const MenuLoggedComponent = ({
  logout,
  className,
  closeHeader,
  displayname,
}) => {
  const handleClose = () => {
    if (typeof closeHeader === "function") {
      closeHeader();
    }
  };
  const isGuest = displayname?.toLowerCase() === "invitado@martinez.com";

  return (
    <div className={className}>
      <span className="nav-link ">{displayname}</span>
      {!isGuest && (
        <>
          <NavLink
            className="nav-link "
            onClick={handleClose}
            to="/tienda/cliente/perfil"
          >
            <i className="fa fa-user"></i> Editar Datos
          </NavLink>
          <NavLink
            className="nav-link "
            onClick={handleClose}
            to="/tienda/cliente/compras"
          >
            <i className="fa fa-cart-arrow-down" aria-hidden="true"></i>{" "}
            Historial de Compras
          </NavLink>
          <NavLink
            className="nav-link "
            onClick={handleClose}
            to="/tienda/cliente/resumencuenta"
          >
            <i className="fa fa-credit-card" aria-hidden="true"></i> Estado de
            Cuenta
          </NavLink>
        </>
      )}
      <button
        type="button"
        className="nav-link login-nav__button"
        onClick={() => logout(() => handleClose())}
      >
        <i className="fa fa-sign-out"></i> Salir
      </button>
    </div>
  );
};

export const CustomLoginNavItemDesktop = (props) => {
  const { displayname, logout, className, logged } = props;
  const [openMenu, setOpenMenu] = useState(false);
  const toggle = () => setOpenMenu(!openMenu);
  const baseClass = className ? className : "";

  if (!logged) {
    return (
      <NavLink
        to="/"
        exact
        className={`nav-link login-nav__trigger ${baseClass}`.trim()}
        activeClassName="active"
      >
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 16 16"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-2"
        >
          <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"></path>
        </svg>
        Iniciar sesion
      </NavLink>
    );
  }

  return (
    <>
      <button
        type="button"
        id="LoginMenuToggle"
        className={`nav-link cursor-pointer login-nav__button ${baseClass}`.trim()}
        onClick={toggle}
      >
        Mi Cuenta
      </button>
      <DropdownMenuLoggedComponent
        logout={logout}
        classNames={baseClass}
        displayname={displayname}
        isOpen={openMenu}
        target="LoginMenuToggle"
        toggle={toggle}
      />
    </>
  );
};

const CustomLoginNavItemMobile = (props) => {
  const { className, logout, logged, closeHeader, displayname } = props;
  const baseClass = className ? className : "";

  if (!logged) {
    const handleClick = () => {
      if (typeof closeHeader === "function") {
        closeHeader();
      }
    };

    return (
      <NavLink
        to="/"
        exact
        className={`nav-link cursor-pointer ${baseClass}`.trim()}
        activeClassName="active"
        onClick={handleClick}
      >
        Ingresar
      </NavLink>
    );
  }

  return (
    <MenuLoggedComponent
      logout={logout}
      className={baseClass}
      closeHeader={closeHeader}
      displayname={displayname}
    />
  );
};

export const LoginNavItem = () => {
  const { clear } = useContext(CartContext);
  const { logged, logout, displayname } = useContext(LoginContext);

  return (
    <CustomLoginNavItemDesktop
      className=""
      logged={logged}
      logout={() => logout(() => clear())}
      displayname={displayname}
    />
  );
};

export const LoginNavItemMobile = (props) => {
  const { clear } = useContext(CartContext);
  const { logged, logout, displayname } = useContext(LoginContext);

  return (
    <CustomLoginNavItemMobile
      className="d-block d-md-none"
      logged={logged}
      logout={() => logout(() => clear())}
      closeHeader={props.closeHeader}
      displayname={displayname}
    />
  );
};
